import { withTheme } from 'theme';
import material3 from 'theme/material3';

const container = withTheme((theme) => ({
  width: '100%',
  minHeight: '100px',
  padding: theme.spacing(2),
  background: material3.color.surfaceContainerLow,
  border: `1px solid ${material3.color.outlineVariant}`,
  borderRadius: material3.shape.large,
  boxShadow: material3.elevation.level1,
  maxWidth: '600px'
}));

const styles = {
  container
};

export default styles;
